module.exports = __webpack_public_path__ + "img/Blog.41e3bf2.svg";